import type { ReactNode } from 'react';
import { Box } from '@mui/material';

import { PracticeSettingsPageContext } from './practiceSettingsContext';
import { practiceSettingsSubtitleSx } from './practiceSettingsTypography';

/** Reuse settings cards as page content, without their standalone card chrome. */
export function PracticeSettingsContent({ children }: { children: ReactNode }) {
  return (
    <PracticeSettingsPageContext.Provider value={true}>
      <Box
        sx={{
          '& .MuiCard-root': {
            boxShadow: 'none',
            border: 0,
            borderRadius: 0,
            bgcolor: 'transparent',
            p: 0,
          },
          '& .MuiCardHeader-root': { px: 0, pt: 0, pb: 3 },
          '& .MuiCardHeader-subheader': practiceSettingsSubtitleSx,
          '& .MuiCardHeader-avatar': { display: 'none' },
          '& .MuiCardHeader-action': { m: 0 },
          '& .MuiCardContent-root': { px: 0, '&:last-child': { pb: 0 } },
        }}
      >
        {children}
      </Box>
    </PracticeSettingsPageContext.Provider>
  );
}
